import Vue from 'vue'
import Router from 'vue-router'


import index from '@/views/index/index' // 活动首页
import activityDetail from '@/views/activityDetail/index' // 活动详情
import activityRules from '@/views/activityRules/index' // 活动规则
import appdownload from '@/views/appdownload/index' // 活动规则
import notfound from '@/views/404'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/Detail',
      name: 'activityDetail',
      component: activityDetail
    },
    {
      path: '/Rules',
      name: 'activityRules',
      component: activityRules
    },
    {
      path: '/appdownload',
      name: 'appdownload',
      component: appdownload
    },
    {
      path: '*',
      name: 'notfound',
      component: notfound
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js